import {
    AdditionalServiceFormFields,
    CustomItemsFormFields,
    ItemsAndConditionsFormFields,
    ProductsFormFields,
    RatesFormFields,
    ServiceFormFields,
    TargetBillFormFields,
} from '../../schemas';
import { RoutingRulesFormStepName, TimingFieldName } from '../../types';

export const RoutingRulesFormFields = {
    name: () => `${RoutingRulesFormStepName.Timing}.${TimingFieldName.Name}`,
    description: () => `${RoutingRulesFormStepName.Timing}.${TimingFieldName.Description}`,
    consumptionDate: () => `${RoutingRulesFormStepName.Timing}.${TimingFieldName.ConsumptionDate}`,
    triggerDay: () => `${RoutingRulesFormStepName.Timing}.${TimingFieldName.TriggerDay}`,
    triggerTime: () => `${RoutingRulesFormStepName.Timing}.${TimingFieldName.TriggerTime}`,
    triggerTiming: () => `${RoutingRulesFormStepName.Timing}.${TimingFieldName.TriggerTiming}`,
    services: () => `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}`,
    serviceEnabled: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Enabled}`,
    serviceOptions: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Options}`,
    serviceProducts: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Products}`,
    serviceProductsType: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Products}.${ProductsFormFields.Type}`,
    additionalServiceProductsType: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.AdditionalServices}.${serviceId}.${AdditionalServiceFormFields.Products}.${ProductsFormFields.Type}`,
    serviceRates: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Rates}`,
    serviceRatesType: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Rates}.${RatesFormFields.Type}`,
    serviceSelectedRates: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Services}.${serviceId}.${ServiceFormFields.Rates}.${RatesFormFields.SelectedRates}`,
    additionalServiceEnabled: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.AdditionalServices}.${serviceId}.${AdditionalServiceFormFields.Enabled}`,
    additionalServiceOptions: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.AdditionalServices}.${serviceId}.${AdditionalServiceFormFields.Options}`,
    additionalServiceProducts: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.AdditionalServices}.${serviceId}.${AdditionalServiceFormFields.Products}`,
    customItems: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.AdditionalServices}.${serviceId}.${AdditionalServiceFormFields.CustomItems}`,
    customItemsType: (serviceId: string) =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.AdditionalServices}.${serviceId}.${AdditionalServiceFormFields.CustomItems}.${CustomItemsFormFields.Type}`,
    companiesEnabled: () =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.CompaniesEnabled}`,
    companies: () => `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.Companies}`,
    prepaidReservationsEnabled: () =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.PrepaidReservationsEnabled}`,
    groupsAndReservationsEnabled: () =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.GroupsAndReservationsEnabled}`,
    groupsAndReservations: () =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.GroupsAndReservations}` as const,
    guestProfilesEnabled: () =>
        `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.GuestProfilesEnabled}`,
    guestProfiles: () => `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.GuestProfiles}`,
    ratesEnabled: () => `${RoutingRulesFormStepName.ItemsAndConditions}.${ItemsAndConditionsFormFields.RatesEnabled}`,
    targetType: () => `${RoutingRulesFormStepName.TargetBill}.${TargetBillFormFields.TargetType}`,
    guestProfileTarget: () =>
        `${RoutingRulesFormStepName.TargetBill}.${TargetBillFormFields.GuestProfileTarget}` as const,
    aggregationType: () => `${RoutingRulesFormStepName.TargetBill}.${TargetBillFormFields.AggregationType}`,
    includeCompanyDetails: () => `${RoutingRulesFormStepName.TargetBill}.${TargetBillFormFields.IncludeCompanyDetails}`,
};
